import { isEnvVarOn, MarketsByProtocol, ProtocolKey, USD_ZERO } from '@silo/types';
import { Markets } from '@silo/ui';
import { useSiloWeb3 } from '@silo/web3';
import { Array, Option, pipe } from 'effect';

const TVL_ENABLED: Record<ProtocolKey, boolean> = {
  mainnetLegacy: isEnvVarOn(() => process.env.NEXT_PUBLIC_MAINNET_LEGACY_TVL_OFF) ? false : true,
  mainnetLlama: isEnvVarOn(() => process.env.NEXT_PUBLIC_MAINNET_LLAMA_TVL_OFF) ? false : true,
  mainnetGrand: isEnvVarOn(() => process.env.NEXT_PUBLIC_MAINNET_GRAND_TVL_OFF) ? false : true,
  arbitrum: isEnvVarOn(() => process.env.NEXT_PUBLIC_ARBITRUM_TVL_OFF) ? false : true,
  optimism: isEnvVarOn(() => process.env.NEXT_PUBLIC_OPTIMISM_TVL_OFF) ? false : true,
  base: isEnvVarOn(() => process.env.NEXT_PUBLIC_BASE_TVL_OFF) ? false : true,
  lrtbase: true,
  local: true,
  anvil: true,
};

interface TvlDisplayProps {
  marketsData: MarketsByProtocol;
}

export function TvlDisplay({ marketsData }: TvlDisplayProps): JSX.Element {
  const { protocolKey } = useSiloWeb3();

  const isTvlEnabled = TVL_ENABLED[protocolKey];

  const tvl = pipe(
    marketsData,
    Array.findFirst((item) => item.protocolKey === protocolKey),
    Option.map(({ tvlUsd }) => tvlUsd),
    Option.getOrElse(() => USD_ZERO)
  );

  return <Markets.TvlDisplay isTvlEnabled={isTvlEnabled} tvl={tvl} />;
}
